module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.20.0@babel-runtime/core-js/object/create.js
 ** module id = 666
 ** module chunks = 0
 **/